import Login from "../views/Login";
import PasswordReset from "../views/PasswordReset";
import SignUp from "../views/SignUp";
import NotFound from "../views/NotFound";

const unauthenticatedRoutes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { title: "Login" }
  },
  {
    path: "/sign-up",
    name: "sign-up",
    component: SignUp,
    meta: { title: "Sign Up" }
  },
  {
    path: "/password-reset/:id",
    name: "password-reset",
    component: PasswordReset,
    props: true,
    meta: { title: "Password Reset" }
  },
  {
    path: "",
    redirect: { name: "Home" }
  },
  {
    path: "*",
    name: "notfound",
    component: NotFound,
    meta: { title: "Not Found" }
  }
];

export default unauthenticatedRoutes;
